import styles from "./NoCardsModal.module.scss";
import failedIcon from "../../../assets/images/payment-status/failed.svg";
import GlobalModalComponent from "../globalModal/GlobalModalComponent";
import { useNavigate } from "react-router-dom";

interface NoCardsModalProps {
  isOpen: boolean;
  onClose: () => void;
  translationData?: any;
}

const NoCardsModal = ({ isOpen, onClose, translationData }: NoCardsModalProps) => {
  const navigate = useNavigate();

  const handleAddCard = () => {
    onClose();
    navigate("/account/bank-cards");
  };

  return (
    <GlobalModalComponent isOpen={isOpen} onClose={onClose}>
      <div className={styles.modal_container}>
        <div className={styles.icon_container}>
          <div className={styles.icon_circle}>
            <img
              src={failedIcon}
              alt="no-cards"
              className={styles.status_icon}
            />
          </div>
        </div>

        <h2 className={styles.title}>
          {translationData?.no_card_title || "Kart tapılmadı"}
        </h2>

        <p className={styles.subtitle}>
          {translationData?.no_card_message || "Ödəniş üçün kartınız yoxdur"}
        </p>

        <div className={styles.buttons}>
          <button className={styles.add_button} onClick={handleAddCard}>
            {translationData?.add || "Əlavə et"}
          </button>
          <button className={styles.close_button} onClick={onClose}>
            {translationData?.close || "Bağla"}
          </button>
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default NoCardsModal;
